/* @jsxImportSource react */

import type { PropsWithChildren } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { sharedTileButtonClass } from './shared';

export type TileButtonProps = PropsWithChildren & {
  /* 
    is the tile an active tile
  */
  mode: 'selected' | 'disabled' | 'disabledAndSelected';
};
/* 
  The TileButton component is a common Button but is extended with loading indicator
  which is visible while the new variation is loading its data
*/
export const TileButton = ({ mode, children }: TileButtonProps) => {
  let classNames =
    'text-color-text-darktransparent bg-color-background-base border-dashed line-through opacity-100!';
  let ariaPressed = false;

  if (mode === 'disabled') {
    classNames += ' border-color-grey';
  } else if (mode === 'disabledAndSelected') {
    classNames += ' border-color-text-dark border-2';
    ariaPressed = true;
  } else {
    classNames =
      'border-color-text-dark opacity-100! outline-[3px]! -outline-offset-2 outline-solid!';
    ariaPressed = true;
  }

  return (
    <Button
      disabled
      size="large"
      className={`${classNames} ${sharedTileButtonClass}`}
      /* this is only for A11Y needs (CROSS-1372) */
      aria-pressed={ariaPressed}
    >
      {children}
    </Button>
  );
};
